import { Deserializable } from '../protocols/deserializable';

export class VbTarget implements Deserializable {
  public targetRecurringPaymentAmount!: number | null;
  public effectiveDate!: string;

  public onDeserialize(): void {}
}
